import { createGroupAPI } from "@/apis/admin-api"
import { useState } from "react"
import { toast } from "sonner"

import { groupStore } from "../admin-group-store"

import CreateLabel from "../../_components/create-form/create-label"
import CreateInput from "../../_components/create-form/create-input"
import CreateButton from "../../_components/create-form/create-button"
import Wrapper from "@/components/wrapper"

const CreateGroupForm = ({ successAction }) => {
  const { apiAction } = groupStore()

  const [groupForm, setGroupForm] = useState({
    group_name: ""
  })

  const changeDirect = (value, key) => {
    setGroupForm((prev) => ({
      ...prev,
      [key]: value
    }))
  }

  const createGroup = async () => {
    const groupName = groupForm.group_name.trim()

    if (!groupName) {
      return toast.error("그룹명을 입력해 주세요.")
    }

    try {
      await createGroupAPI({
        group_name: groupName,
        codes: []
      })

      toast.success(`${groupName} 그룹이 생성되었습니다.`)

      setGroupForm({
        group_name: ""
      })

      await apiAction()
      successAction?.()
    } catch (err) {
      if (err?.response?.status === 400) {
        toast.error(err.response.data.detail)
      }
    }
  }

  return (
    <div className="space-y-6 py-4 px-2">
      <div className="ml-2">
        <h2 className="text-lg font-bold text-slate-800">신규 그룹 등록</h2>

        <p className="mt-1 text-sm text-slate-500">아파트 접근 권한을 관리할 그룹을 생성합니다.</p>
      </div>

      <Wrapper.shadow>
        <h3 className="mb-4 text-base font-semibold text-slate-800">그룹 정보 입력</h3>

        <div>
          <CreateLabel label="그룹명" />

          <CreateInput
            placeholder="예) 호반"
            value={groupForm.group_name}
            onChange={(e) => changeDirect(e.target.value, "group_name")}
          />
        </div>

        <div className="mt-6 flex justify-end">
          <CreateButton onClick={createGroup}>그룹 생성</CreateButton>
        </div>
      </Wrapper.shadow>
    </div>
  )
}

export default CreateGroupForm
